import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface ComponenteConCambiosPendientes {
  confirmarSalida(): boolean | Observable<boolean>;
}

export const cambiosSinGuardarGuard: CanDeactivateFn<ComponenteConCambiosPendientes> =
  (componente) => componente.confirmarSalida();
